const React = require('react')
const PropTypes = require('prop-types')
const NavLogo = require('./nav_logo')
const UserLink = require('./user_link')
const { OwnerComponent } = require('component/viewer/owner')
const log = require('log').create('nav', 'app links') // eslint-disable-line

function AppLinks(props) {
    return (
        <ul className="applinks">
            <OwnerComponent>
                <UserLink {...props} />
            </OwnerComponent>
            {props.render_logo && (
                <li className="logo-container">
                    <NavLogo {...props} />
                </li>
            )}
        </ul>
    )
}

AppLinks.propTypes = {
    render_logo: PropTypes.bool,
}
AppLinks.defaultProps = {
    render_logo: true,
}

module.exports = AppLinks
